import { featureData } from './featureData';

export { featureData };
